/**
 * API Client Utility
 *
 * Provides authenticated fetch wrapper that automatically includes
 * the JWT token in the Authorization header for all API requests.
 */

/**
 * Get the auth token from localStorage
 */
function getAuthToken() {
  return localStorage.getItem("token");
}
const getBaseUrl = () => {
  if (process.env.NODE_ENV === "development") {
    return process.env.REACT_APP_API_URL;
  }
  return process.env.REACT_APP_API_URL || window.location.origin;
};
/**
 * Authenticated fetch wrapper
 * Automatically adds Authorization header with Bearer token
 */
export async function fetchWithAuth(url, options = {}) {
  const token = getAuthToken();

  const isFormData = options.body instanceof FormData;

  // Add Authorization header if token exists
  const headers = {
    ...(options.headers || {}),
  };

  if (!isFormData) {
    headers["Content-Type"] = "application/json";
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(getBaseUrl() + url, {
    ...options,
    headers,
  });

  // Handle 401 Unauthorized - redirect to login
  // if (response.status === 401) {
  //   // Clear auth data
  //   localStorage.removeItem("token");
  //   localStorage.removeItem("userName");
  //   localStorage.removeItem("userEmail");

  //   // Redirect to login page
  //   window.location.href = "/auth/login";
  //   throw new Error("Unauthorized - redirecting to login");
  // }

  return response;
}

/**
 * Convenience methods for common HTTP verbs
 */
export const apiClient = {
  get: async (url, options = {}) => {
    return fetchWithAuth(url, { ...options, method: "GET" });
  },

  post: async (url, body, options = {}) => {
    const isFormData = body instanceof FormData;

    return fetchWithAuth(url, {
      ...options,
      method: "POST",
      body: isFormData ? body : body ? JSON.stringify(body) : undefined,
    });
  },

  put: async (url, body, options = {}) => {
    return fetchWithAuth(url, {
      ...options,
      method: "PUT",
      body: body ? JSON.stringify(body) : undefined,
    });
  },

  delete: async (url, options = {}) => {
    return fetchWithAuth(url, { ...options, method: "DELETE" });
  },

  patch: async (url, body, options = {}) => {
    return fetchWithAuth(url, {
      ...options,
      method: "PATCH",
      body: body ? JSON.stringify(body) : undefined,
    });
  },
};

export default apiClient;
